import { B2BProducts, AuthFlowType, StytchB2BUIConfig, B2BOAuthProviders } from '@stytch/nextjs/b2b'
import { resolvePatientGoogleOneTapConfig } from '@/utilities/stytch/googleOneTapFeature'
import { STYTCH_ACTIVE_SESSION_DURATION, getSharedRedirectURL } from './config'

const STYTCH_PATIENT_EMAIL_TEMPLATE_IDS = {
  login: 'patient_portal_login',
  invite: 'patient_portal_registration',
}

export const PATIENT_GOOGLE_ONE_TAP_PROVIDER = {
  type: B2BOAuthProviders.Google,
  one_tap: true,
  cancel_on_tap_outside: true,
} as const

export type PatientOrganizationConfigOptions = {
  enableGoogleOneTap?: boolean
  /** Keep the staging email / or / Google layout when One Tap is off. */
  includeGoogleOAuth?: boolean
}

export const getOrganizationConfig = (
  options: PatientOrganizationConfigOptions = {},
): StytchB2BUIConfig => {
  const { enableGoogleOneTap, includeGoogleOAuth } = resolvePatientGoogleOneTapConfig(options)
  const redirectURL = getSharedRedirectURL()

  return {
    products: includeGoogleOAuth
      ? [B2BProducts.emailMagicLinks, B2BProducts.oauth]
      : [B2BProducts.emailMagicLinks],
    sessionOptions: { sessionDurationMinutes: STYTCH_ACTIVE_SESSION_DURATION },
    emailMagicLinksOptions: {
      loginRedirectURL: redirectURL,
      signupRedirectURL: redirectURL,
      loginTemplateId: STYTCH_PATIENT_EMAIL_TEMPLATE_IDS.login,
      signupTemplateId: STYTCH_PATIENT_EMAIL_TEMPLATE_IDS.invite,
    },
    ...(includeGoogleOAuth
      ? {
          oauthOptions: {
            loginRedirectURL: redirectURL,
            signupRedirectURL: redirectURL,
            discoveryRedirectURL: redirectURL,
            providers: [
              {
                ...PATIENT_GOOGLE_ONE_TAP_PROVIDER,
                one_tap: enableGoogleOneTap,
              },
            ],
          },
        }
      : {}),
    authFlowType: AuthFlowType.Organization,
  }
}
